import React, { useState, useContext, useMemo, useEffect } from 'react'

import { Drawer, Button } from 'antd'
import { isArray } from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from 'react-redux'

import { GlobalContext } from '../../Providers/GlobalProvider'
import SearchCheckbox from '../antd/Selects/SearchCheckbox'
import { linkAreaInstitution, unLinkAreaInstitution } from '../../utils/api/institution'
import { selectUser } from '../../reducers/UserReducer'
import { InstitutionContext } from '../../Providers/InstitutionProvider'
import { onError, onSuccess, resolvePromises } from '../../utils/apiHelper'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'

export const DOCUMENT_TYPE = 'document'
export const INTERNSHIP_VALIDATION_TYPE = 'validation'
export const INTERNSHIP_DOCUMENT_TYPE = 'internship_document'

const AreaManager = ({ entity, files, width, onClose, onUpdate }) => {
  const { areas } = useContext(GlobalContext)
  const { institution } = useContext(InstitutionContext)

  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [selectedAreas, setSelectedAreas] = useState([])

  const initialChecked = useMemo(() => institution === null ? [] : institution.areas.map((area) => area.id), [institution?.areas])

  useEffect(() => {
    setSelectedAreas(institution === null ? [] : institution.areas)
  }, [institution?.areas])

  const handleAreasCheck = (area, add) => {
    const newSections = add ? [...selectedAreas, area] : selectedAreas.filter(ss => ss.id !== area.id)
    setSelectedAreas(newSections)
  }

  const onSubmit = () => {
    const areArraysDifferent = institution.areas.length !== selectedAreas.length ||
      selectedAreas.some(element => !institution.areas.some(area => area.id === element.id))
    const addAreas = []
    const removeAreas = []

    if (areArraysDifferent) {
      selectedAreas.forEach(element => {
        const isPresent = institution.areas.some(area => area.id === element.id)

        if (!isPresent) {
          addAreas.push(element.id)
        }
      })

      // Trouver les éléments à supprimer
      institution.areas.forEach(element => {
        const isPresent = selectedAreas.some(area => area.id === element.id)

        if (!isPresent) {
          removeAreas.push(element.id)
        }
      })

      const promiseStack = []

      if (removeAreas.length > 0) {
        promiseStack.push(unLinkAreaInstitution(user, institution, removeAreas).then(json => {
          if (json?.data) {
            onSuccess(t('success'))
          } else {
            onError(t('error'))
          }
        }))
      }
      if (addAreas.length > 0) {
        promiseStack.push(linkAreaInstitution(user, institution, addAreas).then(json => {
          if (json?.data) {
            onSuccess(t('success'))
          } else {
            onError(t('error'))
          }
        }))
      }

      resolvePromises(promiseStack).then(onUpdate)
    }
  }

  return (
    <Drawer
      title={t('linked-regions')}
      width={typeof width === 'undefined' ? '30%' : width}
      onClose={onClose}
      visible={!!entity || isArray(files)}
    >
      <SearchCheckbox
        checkAllOption
        items={areas}
        labelKey='localName'
        tooltipKey='localName'
        title={t('Filter data')}
        valueKey='id'
        onCheck={handleAreasCheck}
        onCheckAll={setSelectedAreas}
        initChecked={initialChecked}
      />
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      >
        <Button
          type='primary'
          style={{ textAlign: 'center', width: '80%' }}
          onClick={onSubmit}
        >
          <div
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            className='button-smart-table'
          >
            <FontAwesomeIcon icon='save' />
            &nbsp;
            {t('Save')}
          </div>
        </Button>
      </div>
    </Drawer>
  )
}

export default AreaManager
